import { IQuery, IQueryMediator, key } from 'core-ts-types';
import { ICrossCourseCorequisites } from '../../../components/section_corequisite/builders/cross_course_corequisite_builder';
import { ICrossCourseCorequisitesDatasource } from '../../../components/section_corequisite/datasources/cross_course_corequisite_datasource';
import { CourseDetailsModel } from '../models/course_details_model';
export class CourseDetailsCrossCoreqQuery implements IQuery {
  private _result: Record<key, ICrossCourseCorequisites>;

  constructor(
    QueryMediator: IQueryMediator,
    private ngCourseDetailsModel: CourseDetailsModel,
    private ngCrossCourseCorequisitesDatasource: ICrossCourseCorequisitesDatasource
  ) {
    QueryMediator.registerQuery(this, ngCourseDetailsModel, ngCrossCourseCorequisitesDatasource);
  }

  run() {
    this._result = this.ngCrossCourseCorequisitesDatasource.read();
    return this;
  }
  get result() {
    return this._result;
  }
}

angular.module('capability-ng-scheduler').service('ngCourseDetailsCrossCoreqQuery', CourseDetailsCrossCoreqQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_details/queries/course_details_cross_coreq_query.ts